module.exports = __webpack_public_path__ + "static/media/GD_Logo_New-3.45cf5b11.svg";